import { render, staticRenderFns } from "./AcceleratorLoginSolid.vue?vue&type=template&id=567cd0dc&scoped=true&"
import script from "./AcceleratorLoginSolid.vue?vue&type=script&lang=js&"
export * from "./AcceleratorLoginSolid.vue?vue&type=script&lang=js&"
import style0 from "./AcceleratorLoginSolid.vue?vue&type=style&index=0&id=567cd0dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567cd0dc",
  null
  
)

export default component.exports